export default class MapLocal {
    constructor(store) {
        this._map = Object.create(null)
        if (store) {
            Object.keys(store).forEach(key => {
                this.set(key, store[key])
            })
        }
    }
    set(key, value) {
        this._map[key] = value
    }
    get(key) {
        return this._map[key]
    }
    clear() {
        this._map = Object.create(null)
    }
    size() {
        return Object.keys(this._map).length
    }
    has(key) {
        return Object.prototype.hasOwnProperty.call(this._map, key)
    }
    forEach(callback) {
        Object.keys(this._map).forEach((key) => {
            callback(this._map[key], key, this._map)
        })
    }
    delete(key) {
        if (this.has(key)) {
            delete this._map[key]
            return true
        }
        return false
    }
}